import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { sharepointService } from 'services/syncsharepoint/sharepoint.service';
export type SharepointConnection = {
  authenticated_user: string;
  consent_link: string;
  display_name: string;
  id: string;
  location: string;
  name: string;
  owner: string;
  status_code: string;
  type: string;
};

type UseConnectionOptions = Omit<UseQueryOptions<SharepointConnection[]>, 'queryKey'> & {
  confirmed?: boolean;
};

const useConnection = ({ confirmed, ...options }: UseConnectionOptions = {}) => {
  const query = useQuery({
    queryKey: ['connections', confirmed],
    queryFn: () => sharepointService.getConnections(confirmed ?? null),
    ...options,
  });
  return query;
};

export const useConfirmConnection = () => {
  const client = useQueryClient();
  const mutation = useMutation({
    mutationFn: sharepointService.confirmConnection,
    onSettled: () => client.invalidateQueries({ queryKey: ['connections'] }),
  });
  return mutation;
};

export const useCreateConnection = () => {
  const mutation = useMutation({
    mutationFn: sharepointService.createConnection,
  });
  return mutation;
};

export const useDeleteConnection = () => {
  const client = useQueryClient();
  const mutation = useMutation({
    mutationFn: sharepointService.deleteConnection,
    // onMutate: () => client.cancelQueries({ queryKey: ['connections'] }),
    onSettled: () => {
      client.cancelQueries({ queryKey: ['connections'] });
      client.invalidateQueries({ queryKey: ['connections'] });
    },
  });
  return mutation;
};

export default useConnection;
